import React from "react";
import { PageSection } from "@/components/AppLayout.jsx";
import { AdminGuard } from "@/components/admin/AdminGuard.jsx";
import { useI18n } from "@/coquille-bridge";
import {
  InternalReferentialNotice,
  TerminologyPanel,
  MartialTitlesReferentialPanel,
  TitleApplicationsPanel,
  TitleRegisterPanel,
  TitleAuthorityPanel,
  SempaiTitlePathPanel,
  StudentTitlesView,
} from "@/components/titles/KarateTitleRecognitionPanels.jsx";

const MODULE_NAME_FR = "Shotokan Black Dragon — Titres & Reconnaissances";
const MODULE_NAME_EN = "Shotokan Black Dragon — Titles & Recognitions";

function useLocale() {
  const { lang } = useI18n();
  return lang === "en" ? "en" : "fr";
}

// ——— Admin ———

export function AdminTitlesPage() {
  const locale = useLocale();
  return (
    <AdminGuard>
      <PageSection
        title={locale === "en" ? "Titles referential" : "Référentiel des titres"}
        subtitle={locale === "en" ? MODULE_NAME_EN : MODULE_NAME_FR}
        testId="page-admin-titres"
      >
        <TerminologyPanel />
        <MartialTitlesReferentialPanel allowCrud />
      </PageSection>
    </AdminGuard>
  );
}

export function AdminTitleApplicationsPage() {
  const locale = useLocale();
  return (
    <AdminGuard>
      <PageSection
        title={locale === "en" ? "Title applications" : "Demandes de titres"}
        subtitle={locale === "en" ? MODULE_NAME_EN : MODULE_NAME_FR}
        testId="page-admin-demandes-titres"
      >
        <TitleApplicationsPanel mode="admin" />
      </PageSection>
    </AdminGuard>
  );
}

export function AdminRecognitionsPage() {
  const locale = useLocale();
  return (
    <AdminGuard>
      <PageSection
        title={locale === "en" ? "Recognition register" : "Registre reconnaissances"}
        subtitle={locale === "en" ? MODULE_NAME_EN : MODULE_NAME_FR}
        testId="page-admin-reconnaissances"
      >
        <TitleRegisterPanel />
      </PageSection>
    </AdminGuard>
  );
}

export function AdminTitleAuthorityPage() {
  const locale = useLocale();
  return (
    <AdminGuard>
      <PageSection
        title={locale === "en" ? "Title authority" : "Autorité d'attribution"}
        subtitle={locale === "en" ? MODULE_NAME_EN : MODULE_NAME_FR}
        testId="page-admin-autorite-titres"
      >
        <TitleAuthorityPanel />
      </PageSection>
    </AdminGuard>
  );
}

// ——— Sensei ———

export function SenseiTitlesPage() {
  const locale = useLocale();
  return (
    <PageSection
      title={locale === "en" ? "Martial titles" : "Titres martiaux"}
      subtitle={locale === "en" ? "Criteria summary — title is not automatic" : "Critères résumés — le titre n'est pas automatique"}
      testId="page-sensei-titres"
    >
      <InternalReferentialNotice />
      <TerminologyPanel />
      <MartialTitlesReferentialPanel />
    </PageSection>
  );
}

export function SenseiTitleApplicationsPage() {
  const locale = useLocale();
  return (
    <PageSection
      title={locale === "en" ? "My title applications" : "Mes demandes de titres"}
      testId="page-sensei-demandes-titres"
    >
      <TitleApplicationsPanel mode="sensei" />
    </PageSection>
  );
}

// ——— Sempai ———

export function SempaiTitlesPage() {
  const locale = useLocale();
  return (
    <PageSection
      title={locale === "en" ? "Title path" : "Parcours des titres"}
      subtitle={
        locale === "en"
          ? "Understanding — no validation rights"
          : "Compréhension — pas de droit de validation"
      }
      testId="page-sempai-titres"
    >
      <InternalReferentialNotice />
      <SempaiTitlePathPanel />
    </PageSection>
  );
}

// ——— Étudiant ———

export function MesTitresPage() {
  const locale = useLocale();
  return (
    <PageSection
      title={locale === "en" ? "My titles" : "Mes titres"}
      subtitle={locale === "en" ? MODULE_NAME_EN : MODULE_NAME_FR}
      testId="page-mes-titres"
    >
      <StudentTitlesView />
    </PageSection>
  );
}
